import React, { useState } from "react";
import { PlayIcon } from "@heroicons/react/outline";
import ROUTES from "../../constants/routes";
import { Button, UpgradeCard } from "../../../components";
import ModalVideo from "react-modal-video";
import { useNavigate } from "react-router-dom";

function WelcomePage() {
  const [isOpen, setOpen] = useState(false);
  const [upgrade, setUpgrade] = useState(false);
  let navigate = useNavigate();

  // Redirect to create assesstment
  let createAssessment = () => {
    navigate(`${ROUTES.HOME}`);
  };

  // update Plan

  let updatePlan = () => {
    setUpgrade(!upgrade);
  };

  let onCloseUpgrade = () => {
    setUpgrade(!upgrade);
  };

  return (
    <>
      {isOpen ? (
        <ModalVideo
          channel="youtube"
          autoplay
          isOpen={isOpen}
          videoId="Z3hYshxsIo8"
          onClose={() => setOpen(false)}
        />
      ) : upgrade ? (
        <UpgradeCard type="FREE" onCloseUpgrade={onCloseUpgrade} />
      ) : (
        <div className="2xl:w-5/12 z-20  xl:w-5/12 lg:w-6/12 md:w-8/12 w-10/12  mt-16">
          <div className="bg-white drop-shadow-md rounded-lg  py-8  2xl:px-20 xl:px-20 lg:px-14 md:px-10 px-6">
            {/* begin::Heading */}
            <div className="text-center">
              <p className="font-bold 2xl:text-4xl xl:text-4xl lg:text-4xl md:text-4xl text-3xl text-[#333333]">
                Create & Launch Your Gamified Assessments
              </p>
            </div>
            {/* begin::Heading */}
            {/* begin::Description */}
            <div className="my-8">
              <p className="text-[#313030] font-normal mt-4 text-lg text-center">
                The Talent Games brings you – your very own game creation
                platform. Now create and launch your gamified assessments in
                just 4 easy steps. Roll out your gamified assessments without
                any boundaries or time-zone restrictions.
              </p>
            </div>
            {/* begin::Description */}
            {/* begin:: Button */}

            <div className="my-4 px-10">
              <Button
                type="button"
                customStyle="w-full  text-[1rem]"
                name="Create Assessment Game"
                onClick={() => createAssessment()}
              />
            </div>

            <div className="flex flex-col justify-center items-center">
              <button
                onClick={() => setOpen(true)}
                className="flex flex-row items-center justify-center"
              >
                <PlayIcon className="h-6 w-6  text-[#FFB702] mr-2" />
                <span className="text-center text-[#FFB702] text-lg font-medium">
                  Watch Platform Video
                </span>
              </button>
            </div>
            {/* begin:: Button */}
          </div>
          <div className="text-center pb-20 mt-4">
            <h1 className="font-medium text-xl  text-[#3B4345]">
              Your Current Plan:{" "}
              <b className="font-bold text-xl text-[#007E8C]">FREE</b>
            </h1>
            <button
              onClick={() => updatePlan()}
              className="font-medium underline text-[#007E8C] mt-2"
            >
              Upgrade Your Plan
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default WelcomePage;
